export function exponential(value: any) {
    return (Math.exp(value) - 1) * 100;
}